/* eslint-disable max-len */
import { Plug } from 'SharedDir/router/helpers';
import { RouteRecordRaw } from 'vue-router';

const NewsList = () =>
  import(/* webpackChunkName: "PublicNewsList" */ 'PortalDir/modules/News/pages/List.vue');

const NewsView = () =>
  import(/* webpackChunkName: "PublicNewsView" */ 'PortalDir/modules/News/pages/NewsView.vue');

const routes: Array<RouteRecordRaw> = [
  {
    path: '/news/',
    name: 'news',
    component: NewsList,
  },
  {
    path: '/news/:newsId',
    name: 'news-view',
    component: NewsView,
    props: true,
  },
];

export default routes;
